<div *ngIf="applicationTag">
  <div class="stick-top">
    <mat-toolbar><mat-icon>sell</mat-icon> {{applicationTag.id ? applicationTag.name : 'Create new application tag'}}</mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{applicationTag.id ? 'save' : 'add'}}</mat-icon> {{applicationTag.id ? 'Update' : 'Add'}}
      </button>
      <micro-delete-confirm *ngIf="applicationTag.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead><tr><th colspan="100">Application Tag Details</th></tr></thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [companyId]="applicationTag.companyId" (companyIdChange)="applicationTag.companyId = $event; reload()" [required]="true"></micro-company-select></td></tr>
          <tr><th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th><td><input #name="ngModel" [(ngModel)]="applicationTag.name" required maxlength="200" id="name" name="name"></td></tr>
          <tr><th>Operational Status</th><td><input [(ngModel)]="applicationTag.operationalStatus" maxlength="50" id="operationalStatus" name="operationalStatus"></td></tr>
          <tr><th>Description</th><td><textarea [(ngModel)]="applicationTag.description" maxlength="200" id="description" name="description"></textarea></td></tr>
          <tr>
            <th>Applications</th>
            <td>
              <micro-picklist title="Applications" [all]="allApplications" [(selectedIds)]="selectedApplications" (selectedIdsChange)="ngOnChanges($event)"></micro-picklist>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
